import { createRouter,createWebHashHistory, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

import home from "../components/content/home.vue"
import application_form from "../components/content/application_form.vue"
import team_introduce from "../components/content/team_introduce.vue"
import awards_condition from "../components/content/awards_condition.vue"
import practice_platform from "../components/content/practice_platform.vue"
import support_materials from "../components/content/support_materials.vue"
import application_promotion from "../components/content/application_promotion.vue"
import achievement_summarize from "../components/content/achievement_summarize.vue"

import achievement_innovate from "../components/content/other/achievement_innovate.vue"
import achievement_introduce from "../components/content/other/achievement_introduce.vue"
import team_introduce_details from "../components/content/other/team_introduce_details.vue"

import ImageView from "../views/ImageView.vue"
import VideoView from "../views/VideoView.vue"
const routes = [
  {
    path: '/',
    redirect:'/home' //重定向 将/条跳转到index
  },
  {
    path: '/home',
    component: HomeView,
    children:[
      {
        path:'/home',
        component:home
      },
      {
        path:'/application_form',
        component:application_form
      },
      {
        path:'/team_introduce',
        component:team_introduce
      },
      {
        path:'/awards_condition',
        component:awards_condition
      },
      {
        path:'/practice_platform',
        component:practice_platform
      },
      {
        path:'/support_materials',
        component:support_materials
      },
      {
        path:'/application_promotion',
        component:application_promotion
      },
      {
        path:'/achievement_summarize',
        component:achievement_summarize
      },
      {
        path:'/achievement_innovate',
        component:achievement_innovate
      },
      {
        path:'/achievement_introduce',
        component:achievement_introduce
      },{
        path: '/team_introduce_details',
        component:team_introduce_details
      }
    ]
  },
  {
    path:'/imageView',
    component:ImageView
  },
  {
    path:'/videoView',
    component:VideoView
  }
]

const router = createRouter({
  // history: createWebHistory(process.env.BASE_URL),
  history: createWebHashHistory(),
  routes
})

export default router




